import {
  differenceInDays,
  differenceInMonths,
  differenceInYears,
  parse,
} from "date-fns";

export function validateName(string) {
  if (!string) {
    return false;
  }
  // Validate alphabets & space at 0th position
  return string.match(/^(?![\s])[a-z A-Z]+$/);
}

export function isValidDate(dateInput) {
  if (!dateInput) {
    return false;
  }
  let objDate, mSeconds, day, month, year;

  if (dateInput.length !== 10) {
    return false;
  }

  if (dateInput.substring(2, 3) !== "/" || dateInput.substring(5, 6) !== "/") {
    return false;
  }

  day = dateInput.substring(0, 2) - 0;
  month = dateInput.substring(3, 5) - 1;
  year = dateInput.substring(6, 10) - 0;
  // test year range
  if (year < 1900 || year > 3000) {
    return false;
  }
  // convert dateInput to milliseconds
  mSeconds = new Date(year, month, day).getTime();
  // initialize Date() object from calculated milliseconds
  objDate = new Date();
  objDate.setTime(mSeconds);

  if (
    objDate.getFullYear() !== year ||
    objDate.getMonth() !== month ||
    objDate.getDate() !== day
  ) {
    return false;
  }

  return true;
}

export function validateEmail(string) {
  // eslint-disable-next-line
  const rule =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return rule.test(string);
}

export const calculateAge = (val, withBreakup) => {
  if (!val) {
    if (withBreakup) {
      return { age: 0 };
    }
    return 0;
  }

  const today = new Date();

  const birthDate = parse(val, "dd/MM/yyyy", today);
  const age = differenceInYears(today, birthDate);
  if (withBreakup) {
    const days = differenceInDays(today, birthDate);
    const months = differenceInMonths(today, birthDate);
    return { age, months, days };
  } else {
    return age;
  }
};

export const isValidNomineeName = (userName = "", nomineeName = "") => {
  userName = userName.replace(/\s/g, "");
  nomineeName = nomineeName.replace(/\s/g, "");

  if (nomineeName.match(new RegExp("^" + userName + "$", "i"))) {
    return false;
  }
  return true;
};

export function isValidMobileNumber(val) {
  const rule = /^[6-9]\d{9}$/;
  return rule.test(val);
}

export const isEmptyOrUndefined = (value) => {
	const isUndefined = value === undefined;
	const isNull = value === null;
	const isEmptyObject = !isNull && typeof value === 'object' && Object.keys(value).length === 0;
	const isEmptyString = typeof value === 'string' && value.trim().length === 0;
	const isEmptyValue = isUndefined || isNull || isEmptyObject || isEmptyString;
	return isEmptyValue;
};

export const getPercentageValue = (percent, val) => {
	if (!Number(percent) || !Number(val)) {
		return val;
	}
	return Math.round((val * percent) / 100);
};
